import { Button } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import React, { useEffect, useState } from 'react';
import PageBuilderPreview from '../../../layouts/ui-builder/pages/page-builder/Page-Builder-Preview';
import { formatDateString } from '../../../utils/commonUtils';
import { getUniqueID } from '../../../utils/UiBuilderUtils';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const PreviewPopup = (props) => {
  const { page, handleClose, viewPubishStatus, onEditClick } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [componentsList, setComponentsList] = useState([]);

  useEffect(() => {
    if (page.uiConfigurationPublished !== '') {
      const tempCompList = JSON.parse(page.uiConfigurationPublished).map((e) => {
        return {
          ...e,
          uuxid: getUniqueID(),
        };
      });
      setComponentsList(tempCompList);
    }
  }, [page.uiConfigurationPublished]);

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='delete-popup'>
        <div className='delete-popup-title'>{page?.name}</div>
        <p className='delete-popup-description'>
          {page?.publishedAt !== 0 ? `Published on ${formatDateString(page.publishedAt)}` : '----'}
        </p>
        <div className='d-flex justify-content-center'>
          <div className='page-builder-preview p-2 shadow mt-2 p-0'>
            <div className='fs-16 text-center'>Preview</div>
            <div className='m-2 page-builder-preview-mobile'>
              <div className='d-flex p-1 justify-content-between'>
                <div className='page-builder-preview-mobile-time'>9.41</div>
                <div>
                  <SignalCellularAltIcon className='page-builder-preview-mobile-icon' />
                  <NetworkWifiIcon className='page-builder-preview-mobile-icon' />
                </div>
              </div>
              <div>
                <PageBuilderPreview components={componentsList} />
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-12  d-flex justify-content-end mt-4'>
          <Button
            variant='outlined'
            size='large'
            color='secondary'
            onClick={(e) => handleClose()}
            className='me-4'
          >
            Cancel
          </Button>
          <Button variant='contained' size='large' color='primary' onClick={(e) => onEditClick(e)}>
            Edit Page
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={viewPubishStatus} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default PreviewPopup;
